<template>
  <div
    class="select-file-computer bg-lightest-gray d-flex align-items-center justify-content-center border border-1 rounded rounded-4 border-grey-40 p-50 position-relative"
  >
    <Spinner
      v-show="isLoading"
      :speed="1"
      size="huge"
      message="Loading..."
      class="position-absolute inner-Loader"
    />
    <div class="mage-icon text-center">
      <img src="../../assets/images/image-icon.png" >
      <p class="mt-16 fs-14 text-medium-gray mb-0">
        You can drag and drop file to upload
      </p>
      <label
        for="vfile-upload"
        class="custom-file-upload lf-btn mt-16 py-7 text-dark-gray fs-14 bg-transparent bm-bordered-btn browse-btn border-1 border border-dark-gray file-upload-btn position-relative"
      >Browse file
      </label>
      <div
        v-if="showExtensionError"
        class="mt-5 pt-5 fs-15 text-danger fw-bold text-center d-block">Please only upload .mp4 files</div>
      <div
        v-if="uploadError"
        class="mt-5 pt-5 fs-15 text-danger fw-bold text-center d-block">File cannot be uploaded</div>
      <input
        id="vfile-upload"
        type="file"
        class=""
        accept=".mp4"
        @change="videoUploaded"
      >
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from 'vue-simple-spinner';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import EventBus from '../../EventBus';

export default {
  components: {
    Spinner,
  },
  data() {
    return {
      isLoading:          false,
      showExtensionError: false,
      modalHidden:        true,
      uploadError:        false,
    };
  },
  mounted() {
    this.modalHidden = false;
    EventBus.$on('abortVideoUpload', this.abortVideoFileUpload);
  },
  methods: {
    async videoUploaded(e) {
      const self              = this;
      this.isLoading          = true;
      this.showExtensionError = false;
      this.uploadError        = false;
      this.modalHidden        = false;
      const file              = e.target.files[0];
      const extension         = file.name.split('.').pop();
      if (extension !== 'webm' && extension !== 'mp4') {
        console.log('wrong extension');
        this.isLoading = false;
        alert('Invalid File! (Allowed formats: MP4)');
        return;
      }
      if ((file.size / 1024 / 1024) > 50) {
        this.isLoading = false;
        alert('Video file size can not be more than 50MB');
        return;
      }
      self.postVideo(e);
    },
    async postVideo(event) {
      const self               = this;
      const file               = event.target.files[0];
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '21d29854-fb88-45e6-9a12-b1f4e6c67d45';
      let videoData          = {
        Id:           '',
        Name:         file.name,
        videoDetails: {
          duration: null,
          height:   null,
          width:    null,
          mimeType: '',
        },
        AlternativeVideoUrlsResVersion: []
      };

      const reqFormData = new FormData();
      reqFormData.append('file', file);
      const headers   = {
        'Content-Type': 'text/plain',
      };
      const serverURL = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      axios.post(`https://${serverURL}.com/WebServices/UploadVideos.ashx?userId=${userId}`, reqFormData, { headers })
        .then(async (response) => {
          if (response.data && !this.modalHidden) {
            videoData.videoDetails.VideoSourceUrl = response.data.VirtualPath;
            videoData.videoDetails.videoHighRes   = response.data.HighResUrl;
            videoData.videoDetails.audio          = response.data.AudioUrl;
            videoData.videoDetails.duration       = response.data.Duration;
            videoData.videoDetails.width          = response.data.Width;
            videoData.videoDetails.height         = response.data.Height;
            videoData.videoDetails.ThumbnailVirtualPath      = response.data.ThumbnailVirtualPath;

            videoData.AlternativeVideoUrlsResVersion.push(response.data);
            setTimeout(() => {
              self.isLoading = false;
              EventBus.$emit(ApplicationEventTypes.Video.ADD_NEW_VIDEO_ON_CANVAS, videoData);
              EventBus.$emit('SetPageVideoLength', videoData.videoDetails.duration);
              self.$store.commit('setDisplayAddVideoModal', false);
              this.$store.commit('setIsVideoModel', false);
            }, 10);
          } else {
            alert(response.data.message);
            self.isLoading = false;
          }
        })
        .catch((e) => {
          console.log(error);
          self.isLoading = false;
          alert('File can not be uploaded');
          EventBus.$emit('AddNewVideoOnCanvas', videoData);
        });
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
    abortVideoFileUpload() {
      this.modalHidden = true;
    },
    async waitUntilVideoStateReady(video) {
      try {
        return await new Promise((resolve) => {
          const interval = setInterval(() => {
            if (video.readyState > 0) {
              resolve(video.duration);
              clearInterval(interval);
            }
          }, 200);
        });
      } catch (error) {
        console.log(error);
        return error;
      }
    },
  },
};
</script>
<style scoped>
#vfile-upload {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  opacity: 0;
}
.inner-Loader {
  height: 100%;
  width: calc(100% - 0px);
  background: rgb(255, 255, 255);
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 56;
}
</style>
